import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  tellAILabel: {
    id: 'fabric.editor.ai.ui.components.suggestions.tellAILabel',
    defaultMessage: 'Tell AI',
    description: 'Label for default suggestion option'
  }
});